import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { motion } from "framer-motion";
import { useOnboarding } from "context/OnboardingContext";
import OnboardingLayout from "./OnboardingLayout";
import { useMaterialUIController } from "context";
import { getOnboardingThemeTokens } from "./themeTokens";
import { Icon } from "@mui/material";

const SuccessPage = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const t = getOnboardingThemeTokens({ darkMode, templateTheme: theme });
  const navigate = useNavigate();
  const { sessionToken, claimMeta } = useOnboarding();

  return (
    <OnboardingLayout>
      <MDBox textAlign="center">
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100px"
            height="100px"
            bgcolor="success.main"
            mx="auto"
            mb={4}
            sx={{ boxShadow: t.glowSoft }}
          >
            <Icon sx={{ fontSize: "50px !important", color: "#fff" }}>check</Icon>
          </MDBox>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <MDTypography variant="h2" fontWeight="bold" mb={2}>
            Success!
          </MDTypography>
          <MDTypography variant="body1" mb={5} color="text" sx={{ color: t.textMuted }}>
             {claimMeta?.claim_type === "build_device" ? "Build + Device" : claimMeta?.claim_type === "device" ? "Device" : "Build"} Onboarding Complete
           </MDTypography>
          <MDTypography variant="body1" mb={5} color="text" sx={{ opacity: 0.8 }}>
            Your build has been successfully activated. You can now access your dashboard and start
            managing your devices.
          </MDTypography>
        </motion.div>

        <motion.div
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <MDButton
            variant="gradient"
            color="success"
            size="large"
            onClick={() => navigate("/dashboards/analytics")}
            sx={{ borderRadius: "12px", px: 4, py: 1.5, fontSize: "1rem" }}
          >
            Go to Dashboard
          </MDButton>
        </motion.div>
      </MDBox>
    </OnboardingLayout>
  );
};

export default SuccessPage;
